<script>
export default {
  props: {
    status: { type: String, default: '' },
  },
};
</script>

<template>
  <div
    :class="`status-badge status-badge__${status} rounded-full w-2.5 h-2.5 mr-0.5 rtl:mr-0 rtl:ml-0.5 inline-flex`"
  />
</template>

<style lang="scss" scoped>
.status-badge {
  &__online {
    @apply bg-green-600;
  }
  &__offline {
    @apply bg-slate-500;
  }
  &__busy {
    @apply bg-yellow-500;
  }
  &__training {
    @apply bg-green-200;
  }
  &__adhoc {
    @apply bg-red-900;
  }
  &__away {
    @apply bg-red-500;
  }
  &__lunch {
    @apply bg-black-200;
  }
  &__restroom {
    @apply bg-green-900;
  }
}
</style>
